module.exports = __webpack_public_path__ + "img/broadcast-work-icon11.641c13b6.png";